let SalaryBoundary = {
    SALARY_BOUNDARY_SET_INNER: 'SALARY_BOUNDARY_SET_INNER',
    SALARY_BOUNDARY_SET_OUTER: 'SALARY_BOUNDARY_SET_OUTER',
};

export default SalaryBoundary;
